export default "__VITE_ASSET__V3jV7dU6__"